import { useAuth0 } from '@auth0/auth0-react';
import { DataGrid, DataGridColumn } from '@cimplico/components';
import { useNavigate } from 'react-router-dom';
import { toastNotification } from '../../components/toast/Toast';
import { ROW_SIZES } from '../../constants';
import { useAcceptInvitation } from '../../queries/use-accept-invitation';
import { useDeleteInvitation } from '../../queries/use-delete-invitation';
import { useInvitations } from '../../queries/use-invitations';
import { Invitation } from '../../types/invitation';
import InvitationRow from './InvitationRow';

const columns: DataGridColumn[] = [
    {
        header: 'Firm',
        alignment: 'left',
        width: '1.5fr',
    },
    {
        header: 'Role',
        alignment: 'center',
        width: '1fr',
    },
    {
        header: 'Invited by',
        alignment: 'left',
        width: '1.5fr',
    },

    {
        header: 'Expires',
        alignment: 'left',
        width: '1.5fr',
    },
    {
        header: '',
        alignment: 'center',
        width: '1.5fr',
    },
];

function InvitationsTable(): JSX.Element {
    const invitationsQuery = useInvitations();
    const deleteInvitationQuery = useDeleteInvitation();
    const acceptInvitationQuery = useAcceptInvitation();

    const navigate = useNavigate();

    function deleteInvitation(id: string): void {
        deleteInvitationQuery.mutate(id);
    }

    function acceptInvitation(invitation: Invitation): void {
        const shortId = invitation.firm.shortId;

        acceptInvitationQuery.mutate(invitation.id, {
            onSuccess: () => {
                toastNotification('success', 'Invitation accepted!');
                navigate(`/${shortId}/dashboard`);
            },
        });
    }

    if (invitationsQuery.isError) {
        return <></>;
    }

    if (!invitationsQuery.isSuccess) {
        return <></>;
    }

    const { invitations } = invitationsQuery.data;

    return (
        <DataGrid
            rowSizes={ROW_SIZES}
            columns={columns}
            totalRows={100}
            disablePagination
            isLoading={invitationsQuery.isLoading || invitationsQuery.isFetching}
            emptyMessage="No invitations"
            isSelectable={false}
        >
            {invitations.map((invite) => {
                return (
                    <InvitationRow
                        id={invite.id}
                        key={invite.id}
                        invitation={invite}
                        disableActions={deleteInvitationQuery.isLoading || acceptInvitationQuery.isLoading}
                        onDelete={deleteInvitation}
                        onAccept={acceptInvitation}
                    />
                );
            })}
        </DataGrid>
    );
}
export default InvitationsTable;
